import React, { useCallback, useEffect } from 'react';
import { Box, Flex, Link, Text } from 'rebass';
import ErrorDetails from '../NotifyProvider/ErrorDetails';
import { goToHomePage } from '../../services/auth';
import { feedback } from '../../sentry';
import Button from '../Button/Button';
import { baseMonoStack } from '../../theme/text';

interface ErrorFallbackProps {
  error: unknown;
  resetError: () => void;
}

export default function ErrorFallback({
  error,
  resetError,
}: ErrorFallbackProps): JSX.Element {
  const reportBug = useCallback(async () => {
    const form = await feedback.createForm();
    form.appendToDom();
    form.open();
  }, []);

  return (
    <Flex
      role="alert"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <ErrorDetails
        maxWidth="80%"
        maxHeight="calc(100vh - 150px)"
        px="20px"
        pt="20px"
        errorDetails={error}
      />
      {/*<Text>*/}
      {/*  Something went wrong: {error.message}*/}
      {/*</Text>*/}
      <br />
      <Text px="20px" pb="20px">
        If error persists{' '}
        <Link
          href="javascript:void(0)"
          sx={{ color: 'primary' }}
          onClick={reportBug}
        >
          report a bug
        </Link>{' '}
        or contact support: 503-830-0170
      </Text>
      <Flex flexDirection="row">
        <Button
          icon="bell"
          onClick={reportBug}
          ml={3}
          alignSelf="center"
          variant="primary"
          size="medium"
        >
          Report Bug
        </Button>
        <Button
          icon="repeat"
          onClick={goToHomePage}
          ml={3}
          alignSelf="center"
          variant="primary"
          size="medium"
        >
          Reload
        </Button>
      </Flex>
      {/*<Button onClick={resetError}>Clear</Button>*/}
    </Flex>
  );
}
